import { MongoBaseFunctionParameterMapping as _MongoBaseFunctionParameterMapping } from "./MongoForm/types";

export { default as MongoForm } from "./MongoForm/MongoForm";

export type MongoBaseFunctionParameterMapping = _MongoBaseFunctionParameterMapping;
